import { render, staticRenderFns } from "./EmptyingForm.vue?vue&type=template&id=38c57ef9&"
import script from "./EmptyingForm.vue?vue&type=script&lang=js&"
export * from "./EmptyingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports